import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { PermissionEnum, PermissionDenied, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import Header from '../../components/user-list/header/header';
import ROUTES from '../../routes';
import {
  useLazyGetEmployeesBaseDictionariesQuery,
  useLazyGetActiveCurrenciesQuery,
  useLazyGetAdministrationCountriesQuery,
  useLazyGetEmployeesDictionariesQuery,
} from '../../store/dictionaries/service';
import Columns from './columns';
import { useLazyGetUserValidatorsQuery } from './store/services/users';

import cn from './styles.module.css';

const UserListPage = () => {
  const [activeTab, setActiveTab] = useState<
    'accessRights' | 'notificationSettings'
  >('accessRights');
  const navigate = useNavigate();

  const { activePermissions, roles, activeCurrencies, countries, users } =
    useAppSelector((state) => state.administrationDictionaries);

  const [getEmployeesBaseDictionaries] =
    useLazyGetEmployeesBaseDictionariesQuery();
  const [getActiveCurrencies] = useLazyGetActiveCurrenciesQuery();
  const [getEmployeesCountries] = useLazyGetAdministrationCountriesQuery();
  const [getEmployeesDictionaries] = useLazyGetEmployeesDictionariesQuery();
  const [getValidators] = useLazyGetUserValidatorsQuery();

  useEffect(() => {
    if (!roles) {
      getEmployeesBaseDictionaries();
    }

    if (!activeCurrencies) {
      getActiveCurrencies();
    }

    if (!countries) {
      getEmployeesCountries();
    }

    if (activePermissions?.includes(PermissionEnum.USERS_LIST) && !users) {
      getValidators();
      getEmployeesDictionaries();
    }
  }, [activePermissions, roles, activeCurrencies, countries, users]);

  useEffect(() => {
    let title = 'Employees list';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.usersLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_ADMINISTRATION) ||
      !activePermissions.includes(PermissionEnum.USERS_LIST) ||
      !activePermissions.includes(PermissionEnum.USERS_ROLES_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.roles}>
          <Header
            onClickAdd={
              activePermissions?.includes(PermissionEnum.USERS_CREATE_ACTION)
                ? () => navigate(ROUTES.USER_ADD)
                : undefined
            }
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className={cn.columns}>
            <Columns activeTab={activeTab} />
          </div>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default UserListPage;
